import { H3, Stars, UniversalLink, Image } from "@template/components";
import * as S from "./styles.ts";
import ioReviews from "@/lib/images/reviewers/ioReviews.png";
import trustpilot from "@/lib/images/reviewers/trustpilot.png";
import googleReviews from "@/lib/images/reviewers/googleReviews.png";

export const CustomerReviewsSectionHeader = ({
  internal,
  headline,
}: {
  internal: boolean;
  headline: string;
}) => {
  const starSize = 15;
  return (
    <S.CustomerReviewsSectionHeadline>
      {internal && (
        <S.ReviewsSections>
          <Stars />
          <S.ReviewersSection>
            <p>From 3500+ reviews from</p>
            <S.ReviewersIcons>
              <UniversalLink
                target="_blank"
                href="https://www.reviews.co.uk/company-reviews/store/yayyay-ltd?utm_source=yayyay-ltd&utm_medium=widget&utm_campaign=badge-ribbon"
              >
                <Image
                  height={20}
                  width={20}
                  src={ioReviews}
                  alt="Reviews IO icon"
                />
              </UniversalLink>
              <UniversalLink
                href="https://uk.trustpilot.com/review/yay.com"
                target="_blank"
              >
                <Image
                  height={20}
                  width={20}
                  src={trustpilot}
                  alt="Trustpilot reviews icon"
                />
              </UniversalLink>

              <UniversalLink
                target="_blank"
                href="https://www.google.com/search?q=yay+voip&sca_esv=361416631b2a74db&ei=oMVZZqHqJceVhbIPre-l4A8&ved=0ahUKEwihurj-9LeGAxXHSkEAHa13CfwQ4dUDCBA&uact=5&oq=yay+voip&gs_lp=Egxnd3Mtd2l6LXNlcnAiCHlheSB2b2lwMgsQABiABBiRAhiKBTIFEAAYgAQyBRAAGIAEMggQABgWGB4YDzILEAAYgAQYhgMYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYgAQYogQyCBAAGKIEGIkFSIwUUOUGWMgScAN4AJABAJgBlQGgAcEHqgEDMS43uAEDyAEA-AEBmAILoALmB8ICCRAAGLADGAgYHsICDhAAGIAEGLADGIYDGIoFwgILEAAYgAQYsAMYogTCAg8QABiABBhDGIoFGEYY-QHCAhQQLhiABBiRAhjHARiKBRiOBRivAcICCxAAGIAEGLEDGIMBwgIKEC4YgAQYQxiKBcICERAuGIAEGLEDGNEDGIMBGMcBwgIFEC4YgATCAikQABiABBhDGIoFGEYY-QEYlwUYjAUY3QQYRhj5ARj0Axj1Axj2A9gBAcICFhAuGIAEGLEDGNEDGEMYgwEYxwEYigXCAgoQABiABBhDGIoFwgIQEAAYgAQYsQMYQxiDARiKBcICEhAAGIAEGLEDGEMYigUYRhj5AcICDRAAGIAEGLEDGEMYigXCAggQLhiABBixA8ICLBAAGIAEGLEDGEMYigUYRhj5ARiXBRiMBRjdBBhGGPkBGPQDGPUDGPYD2AEBwgIOEC4YgAQYxwEYjgUYrwHCAgcQABiABBgKwgIHEC4YgAQYCsICBhAAGBYYHpgDAIgGAZAGBLoGBggBEAEYE5IHAzQuN6AH-V0&sclient=gws-wiz-serp#lrd=0x4875d0915c7d84ab:0xcdb88a3a6e150faa,1,,,,"
              >
                <Image
                  height={20}
                  width={20}
                  src={googleReviews}
                  alt="Google reviews icon"
                />
              </UniversalLink>
            </S.ReviewersIcons>
          </S.ReviewersSection>
        </S.ReviewsSections>
      )}
      <H3>{headline}</H3>
    </S.CustomerReviewsSectionHeadline>
  );
};
